import type {TreePane} from '@github-ui/repos-file-tree-view'
import {createContext, use} from 'react'

type TreePaneContextValue = TreePane & {
  onFindFilesShortcut: () => void
}

const TreePaneContext = createContext<TreePaneContextValue | null>(null)

export function TreePaneProvider({
  children,
  initialState,
}: {
  children: React.ReactNode
  initialState: TreePaneContextValue
}) {
  return <TreePaneContext value={initialState}>{children}</TreePaneContext>
}

export function useTreePaneContext() {
  const context = use(TreePaneContext)
  if (!context) {
    throw new Error('useTreePaneContext must be used within TreePaneProvider')
  }
  return context
}
